import { Button } from "@mui/material"
import { FaFolderOpen, FaQuestionCircle, FaTimes } from "react-icons/fa"
import SearchIcon from '@mui/icons-material/Search';
import { BACKEND } from "../config/configEnvs";
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen";
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen";
import PaginationItem from "../components/ui/components/Pagination";
import { FormatDateToDDMMYY } from "../utils/FormatDate";
import Tooltip from "../components/ui/ToolTip";
import ItemRowVentasComercial from "../components/ventasComercial/ItemRowVentasComercial";
import { Category } from "@mui/icons-material";
import { useSelector } from "react-redux";

const VentasProyectos = () => {

  const user = useSelector((state) => state.auth.user)

  const [limit, setLimit] = useState(25)
  const [page, setPage] = useState(1)

  const [loadingStatus, setLoadingStatus] = useState(false)
  const [services, setServices] = useState([])

  const [solutions, setSolutions] = useState([])

  const [totalDocs, setTotalDocs] = useState(0)
  const [totalPages, setTotalPages] = useState(0)
  
  const [brandName, setBrandName] = useState("")
  const [activeAgency, setActiveAgency] = useState(false)

  const [onlyAudiovisual, setOnlyAudiovisual] = useState(true)

  const getServices = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/servicios?limit=0`)
      setSolutions(response.data.docs)
    } catch (e) {
      return false
    }
  }

  const getClients = async () => {
    try {

      setLoadingStatus(true)
      var url = `${BACKEND}/api/serviciosCotizaciones?where[cotizacion.estado][equals]=Exito&page=${page}&limit=${limit}&where[servicio.categoria][not_equals]=Hosting y dominio`

      if (brandName) {
        url += `&where[cotizacion.cliente.razonSocial][like]=${brandName}`
      }

      if (activeAgency) {
        url += `&activeAgency=${activeAgency}`
      }

      if (onlyAudiovisual) {
        url += `&where[produccionAudiovisual][equals]=true`
      } else {
        url += `&where[produccionAudiovisual][not_equals]=true`
      }

      const response = await axios.get(url)
      
      setServices(response.data.docs)
      setTotalPages(response.data.totalPages)
      setTotalDocs(response.data.totalDocs)
    } catch (e) {
      toast.error("Error al obtener los servicios: " + e)
    } finally {
      setLoadingStatus(false)
    }
  }

  const handlePageChange = (event, value) => { // Cambiar la página
    setPage(value)
  }

  useEffect(() => {
    getClients()
    getServices()
  }, [])

  useEffect(() => {
    getClients()
  }, [limit, page, onlyAudiovisual])

  useEffect(() => { // Solo se ejecuta cuando se vacea la barra de búsqueda
    if (brandName === "") {
      getClients(); // Solo se ejecuta cuando se reinicia la búsqueda
      setPage(1); // Reiniciar la paginación si es necesario
    }
  }, [brandName]);
  
  const handleResetSearch = () => { // Resetea la búsqueda
    setBrandName(""); // Cambiar el estado
  };

  const handleSearchClients = () => { // Buscamos clientes y colocamos página 1
    setPage(1)
    getClients()
  }

  return (
    <div className="flex flex-col h-screen w-full">

      {/* NavBar */}
      <div className="flex flex-row px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between">
          
          <div className="flex items-center gap-4 py-4">
            <FaFolderOpen className="text-zinc-700 text-2xl" />
            <h2 className="text-2xl font-bold text-zinc-700">Ventas Proyectos</h2>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">
           
            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span>Límite:</span>
              <select
                value={limit}
                onChange={(e) => setLimit(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="25">25</option>
                <option value="35">35</option>
                <option value="45">45</option>
                <option value="55">55</option>
                <option value="65">65</option>
              </select>
            </div>

            <div className="relative w-full">
              <input
                type="text"
                placeholder="Buscar marca"
                className="w-[16rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                value={brandName}
                onChange={(e) => setBrandName(e.target.value)}
              />
              {brandName && (
                <FaTimes
                  onClick={() => handleResetSearch()}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer"
                />
              )}
            </div>

            <div>
              <Button 
                variant="contained"
                endIcon={<SearchIcon />}
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontFamily: "poppins",
                  padding: "4px 24px",
                  backgroundColor: "#ff6400",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "8px",
                  '&:hover': {
                    backgroundColor: "#bb4a03",
                  }
                }}
                onClick={() => handleSearchClients()}
              >
                Buscar
              </Button>
            </div>

          </div>

        </div>
      </div>

      {/* Filtros */}       
      <div className="flex flex-row items-center justify-center bg-gray-100 mt-1 mb-1 py-1 gap-8">
        <div className="flex flex-row items-center justify-center gap-4">
          <span className="text-xs">Mostrar solo proyectos que requieren audiovisual</span>
          <input
            type="checkbox"
            className="rounded-md border-gray-400 hover:cursor-pointer"
            checked={onlyAudiovisual}
            onChange={(e) => setOnlyAudiovisual(e.target.checked)}
          />
        </div>
      </div>

      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {loadingStatus ? (
          <LoadingScreen />
          ) : (
            services.length === 0 ? (
              <NoDataScreen />
            ) : (
              <table className="w-full table-fixed">
                <thead className="bg-white sticky top-0 z-50">
                  <tr className="w-full text-gray-700 text-center text-sm font-bold">

                    <td className="sticky z-20 left-0 w-[250px] px-4 py-2 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Cliente
                    </td>
                    
                    <td className="w-[150px] px-2 py-2 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Estado proyecto audiovisual
                    </td>
                    
                    <td className="w-[200px] px-4 py-2 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Servicio
                    </td>

                    <td className="w-[100px] px-2 py-2 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Plan
                    </td>

                    <td className="w-[150px] px-2 py-2 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      <div className="flex flex-row gap-2 justify-center items-center">
                        Ingreso   
                        <Tooltip content={"Fecha de cuando el cliente realizó el primer pago."}>
                          <div>
                            <FaQuestionCircle/>
                          </div>
                        </Tooltip>   
                      </div>                
                    </td>

                    <td className="w-[150px] px-2 py-2 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      <div className="flex flex-row gap-2 justify-center items-center">
                        Inicio  
                        <Tooltip content={"Fecha de la primera reunión del área operativa con el cliente."}>
                          <div>
                            <FaQuestionCircle/>
                          </div>
                        </Tooltip>   
                      </div>                 
                    </td>

                    <td className="w-[150px] px-1 py-1 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      <div className="flex flex-row gap-2 justify-center items-center">
                        Envío info.
                        <Tooltip content={"Fecha en la que el cliente terminó de enviar el 100% de la información."}>
                          <div>
                            <FaQuestionCircle/>
                          </div>
                        </Tooltip>
                      </div> 
                    </td>

                    <td className="w-[150px] px-2 py-2 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      <div className="flex flex-row gap-2 justify-center items-center">
                        Fin
                        <Tooltip content={"Fecha establecida por administración para terminar el proyecto."}>
                          <div>
                            <FaQuestionCircle/>
                          </div>
                        </Tooltip>
                      </div>
                    </td>

                    <td className="w-[150px] px-2 py-2 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      <div className="flex flex-row gap-2 justify-center items-center">
                        Terminación
                        <Tooltip content={"Fecha de cuando se terminó la web, el cliente ya no tiene más cambios y se empieza el proceso de cobranza por parte de administración."}>
                          <div>
                            <FaQuestionCircle/>
                          </div>
                        </Tooltip>
                      </div>
                    </td>

                    <td className="w-[150px] px-2 py-2 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      <div className="flex flex-row gap-2 justify-center items-center">
                        Entrega
                        <Tooltip content={"Fecha de entrega de la web una vez el cliente pagó el 100%. Entrega de credenciales, video de capacitación, migracion al hosting del cliente (en caso sea necesario), etc. Servicio 100% completado."}>
                          <div>
                            <FaQuestionCircle/>
                          </div>
                        </Tooltip>
                      </div>
                    </td>

                    <td className="w-[150px] px-2 py-2 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Vendedor
                    </td>

                    <td className="w-[250px] px-2 py-2 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Testimonio del cliente en video
                    </td>

                    <td className="w-[250px] px-2 py-2 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Revisión en Google Maps
                    </td>

                    <td className="w-[250px] px-2 py-2 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Revisión en Facebook
                    </td>

                    <td className="w-[150px] px-2 py-2 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Video subido a plataformas
                    </td>

                    <td className="w-[200px] px-2 py-2 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Se le ofreció otros servicios
                    </td>

                    <td className="w-[270px] px-2 py-2 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Servicios interés
                    </td>

                  </tr>
                </thead>

                <tbody>
                  {services.map((s, i) => (
                    <ItemRowVentasComercial 
                      key={i}
                      s={s}
                      setServices={setServices}
                      solutions={solutions}
                      user={user}
                    />
                  ))}

                </tbody>
              </table>  
            )
          )
        }
      </div>

      {/* Paginador */}
      <PaginationItem
        actualDocs={services.length}
        totalDocs={totalDocs}
        entity={"servicios"}
        totalPages={totalPages}
        actualPage={page}
        handlePageChange={handlePageChange}
      />

    </div>
  )
}

export default VentasProyectos